import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, setToken, getToken } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined=checking, null=logged out, obj=in

  useEffect(() => {
    if (!getToken()) { setUser(null); return; }
    api.me().then(setUser).catch(() => { setToken(null); setUser(null); });
  }, []);

  const login = useCallback(async (username, password) => {
    const { token, user } = await api.login(username, password);
    setToken(token);
    setUser(user);
  }, []);

  const register = useCallback(async (username, password, email, betaCode) => {
    const { token, user } = await api.register(username, password, email, betaCode);
    setToken(token);
    setUser(user);
  }, []);

  const logout = useCallback(() => { setToken(null); setUser(null); }, []);

  return (
    <AuthContext.Provider value={{ user, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
